import DashboardLayout from "./DashboardLayout";
export default DashboardLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/dashboard/DashboardLayout/index.tsx